export function applyShadowToNav() {
  const scrollY = window.scrollY
  const navLogo = document.querySelector('.c-nav__logo-static')
  const nav = document.querySelector('section.nav')
  if (scrollY == 0) {
    navLogo.classList.remove('animate-nav-in')
    nav.classList.remove('c-nav--scrolled')
    navLogo.classList.add('animate-nav-out')
  } else {
    navLogo.classList.remove('animate-nav-out')
    navLogo.classList.add('animate-nav-in')
    nav.classList.add('c-nav--scrolled')
  }
}

export function scrollButton(btn) {
  const sections = document.getElementsByTagName('section')
  if (btn) {
    btn.addEventListener('click', (event) => {
      event.preventDefault()
      sections[2].scrollIntoView({ behavior: 'smooth' })

      const content = sections[2]
      const scrolled = window.scrollY
      const menuHeightOffset = document.querySelector('.c-nav--desktop').getBoundingClientRect()
        .height
      const distance = content.offsetTop - scrolled - menuHeightOffset

      window.scrollBy({ top: distance, left: 0, behavior: 'smooth' })
    })
  }
}

export function scrollToEventHandler(event) {
  if (event.type === 'click') {
    event.preventDefault()
    const id = event.target.getAttribute('href')
    const target = document.querySelector(id)

    const scrolled = window.scrollY
    const menuHeightOffset = document.querySelector('.c-nav--desktop').getBoundingClientRect()
      .height
    const distance = target.offsetTop - scrolled - menuHeightOffset

    window.scrollBy({ top: distance, behavior: 'smooth' })
  }
}

export function scrollToFinishSection() {
  const trigger = document.querySelector('.js-scroll-to-product-finishes')
  if (trigger) {
    trigger.addEventListener('click', (e) => {
      if (event.type === 'click') {
        event.preventDefault()
        const target = document.querySelector('.product-finish')
        if (target) {
          const content = target
          const scrolled = window.scrollY
          const menuHeightOffset = document.querySelector('.c-nav--desktop').getBoundingClientRect()
            .height
          const distance = content.offsetTop - scrolled - menuHeightOffset
          window.scrollBy({ top: distance, left: 0, behavior: 'smooth' })
        }
      }
    })
  }
}
